import Image from 'next/image';
import { Wrapper } from './styles';

const Author = ({ author }) => (
  <Wrapper>
    <div className="position-information">
      {!author?.code && (
        <>
          <Image
            priority
            width={57}
            height={57}
            className="avatar"
            src={author?.avatar_urls?.['48']}
            alt="author"
          />
          <span className="name">{author?.name}</span>
          <div className="separator" />
        </>
      )}
      <div className="social-media">
        <a
          href="https://www.facebook.com/cloudezbr"
          target="_blank"
          rel="noreferrer"
        >
          <Image
            priority
            width={24}
            height={24}
            src="/facebooktransparent.png"
          />
        </a>

        <div className="separator-icon" />

        <a
          href="https://www.linkedin.com/company/cloudez"
          target="_blank"
          rel="noreferrer"
        >
          <Image
            priority
            width={24}
            height={24}
            src="/linkedintransparent.png"
          />
        </a>
      </div>
    </div>
  </Wrapper>
);

export default Author;
